import { render } from "./CourierId.vue?vue&type=template&id=34955bc4&scoped=true&ts=true"
import script from "./CourierId.vue?vue&type=script&lang=ts"
export * from "./CourierId.vue?vue&type=script&lang=ts"

import "./CourierId.vue?vue&type=style&index=0&id=34955bc4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34955bc4"]])

export default __exports__